import { RepositoryScreenSectionsController } from './repository-screen-sections.controller'

function repositoryScreenSections () {
  return {
    scope: {
      sections: '<',
      modalState: '<',
      currentPage: '<',
      mustShowFilters: '<',
      selectedAssets: '<',
      selectedFolders: '<',
      allowedAssetExtensionsSelection: '<',
      searching: '<',
      pagination: '<',
      openFolder: '&',
      goBackFolder: '&',
      pricing: '<',
      singleAttach: '<'
    },
    restrict: 'E',
    templateUrl: '/repository/directives/repository-screen-sections/repository-screen-sections.html?$$REVISION$$',
    controller: RepositoryScreenSectionsController
  }
}

export { repositoryScreenSections }
